// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"da4343c2","885":"02b6405b"}[chunkId] + ".chunk.js";
};